// Colonnes du tableau /produits. Partagé avec la page Configuration, qui définit
// les colonnes visibles par défaut pour l'entreprise (clé produits_colonnes_visibles).
export const PRODUITS_COLONNES = [
  { key: 'produit',     label: 'Produit',       always: true  },
  { key: 'type',        label: 'Conditionnements', def: true  },
  { key: 'prixAchat',   label: 'Prix achat',    def: false },
  { key: 'prixVente',   label: 'Prix vente',    def: true  },
  { key: 'stock',       label: 'Stock',         def: true  },
  { key: 'statut',      label: 'Statut',        def: true  },
  { key: 'fournisseur', label: 'Fournisseur',   def: false },
  { key: 'codeBarres',  label: 'Code-barres',   def: false },
  { key: 'description', label: 'Description',   def: false },
];

export const PRODUITS_COLONNES_DEFAUT = PRODUITS_COLONNES
  .filter(c => c.always || c.def).map(c => c.key);

// Colonnes visibles d'après la configuration (colonnes fixes toujours incluses,
// clés inconnues ignorées) ; défaut de l'application si non configuré.
export const colonnesVisiblesConfig = (valeur) => {
  if (!Array.isArray(valeur)) return new Set(PRODUITS_COLONNES_DEFAUT);
  return new Set(PRODUITS_COLONNES
    .filter(c => c.always || valeur.includes(c.key)).map(c => c.key));
};
